// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { bool } from 'prop-types';

import PrivateOfferEditor from 'Containers/Offers/PrivateOfferEditor';
import SavedOfferEditor from 'Containers/Offers/SavedOfferEditor';

const OfferEditorPage = memo(({ isPrivate }) => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content"
        />
        <title>{ t('offers.editorTitle') }</title>
        <body className="OfferEditorPage" />
      </Helmet>
      { isPrivate ? <PrivateOfferEditor /> : <SavedOfferEditor /> }
    </>
  );
});

OfferEditorPage.displayName = 'OfferEditorPage';

OfferEditorPage.propTypes = {
  isPrivate: bool
};

export default OfferEditorPage;
